// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Autoupdate_wrapper__nVzBS","grayBackground":"Autoupdate_grayBackground__M7zCw"};